/* eslint-disable no-unused-expressions */
import * as React from "react";
import { Table, Button } from "antd";
import { useState, useEffect } from "react";
import { Space } from "antd";

import "dayjs/locale/es";
import { EditOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";

import {
  toColombianPesos,
  formatIntDate,
  formatDate,
} from "../../../utils/utils";

dayjs.extend(calendar);

export const ProductsTable = ({
  dataSource,
  onHandleEvent,
  onConfirm,
  enabledToEdit,
}) => {
  const [tableData, setTableData] = useState(dataSource);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const newData = [...tableData];
    setTableData(newData);
  }, []);

  const onInputChange = (key, index, type) => (e) => {
    const newData = [...tableData];

    newData[index][key] =
      type !== "date"
        ? e.target.value
        : parseInt(formatDate(e.$d).replace(/-/g, ""));
    setTableData(newData);
  };

  const handleOnConfirm = () => {
    setIsDisabled(true);
    onConfirm(tableData);
  };

  const handleEditProducts = () => {
    setIsDisabled(!isDisabled);
  };

  const columns = [
    {
      title: "Material",
      dataIndex: "material",
      key: "material",
    },
    {
      title: "Cant. Total",
      dataIndex: "cantidad",
      key: "cantidad",
    },
    {
      title: "Costo",
      dataIndex: "costo",
      key: "costo",
      render: (cost) => <span>{toColombianPesos(cost)}</span>,
    },
    {
      title: "Fecha Promesa",
      dataIndex: "fechaPromesa",
      key: "fechaPromesa",
      render: (text) => (text ? formatIntDate(text.toString()) : ""),
    },
    {
      title: "Fecha Entrega",
      dataIndex: "fechaEntrega",
      key: "fechaEntrega",
      render: (text) => (text ? formatIntDate(text.toString()) : ""),
    },
    {
      title: "Tirilla",
      dataIndex: "tirilla",
      key: "tirilla",
    },
    {
      title: "Referencia",
      dataIndex: "referencia",
      key: "referencia",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => onHandleEvent(record)}
          >
            Mostrar Eventos
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="products-editable">
      <div className="products-editable-actions">
        {(!enabledToEdit && isDisabled) && (
          <Button
            type="link"
            onClick={handleEditProducts}
            icon={<EditOutlined />}
          >
            Editar
          </Button>
        )}
        {!isDisabled && (
          <Button type="default" onClick={handleOnConfirm} className="btn-primary"
          >
            Actualizar Productos
          </Button>
        )}
      </div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={tableData}
        pagination={false}
      />
    </div>
  );
};
